module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_tape_deskstop.ca368e0b.jpg";